import React, { createContext, useContext, useState, useCallback } from "react";

const QuoteCtx = createContext(null);
export const useQuote = () => useContext(QuoteCtx);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState("");
  const openQuote = useCallback((product = "") => {
    setPrefill(product);
    setOpen(true);
  }, []);
  const closeQuote = useCallback(() => setOpen(false), []);
  return (
    <QuoteCtx.Provider value={{ open, prefill, openQuote, closeQuote }}>
      {children}
    </QuoteCtx.Provider>
  );
};
